import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=2b004e57&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b004e57')) {
      api.createRecord('2b004e57', component.options)
    } else {
      api.reload('2b004e57', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=2b004e57&", function () {
      api.rerender('2b004e57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/ImageCarousel.vue"
export default component.exports